// node-modules
import React from 'react';
import { Text, View } from '@upstox/upstox-ui';
import { observer } from 'mobx-react';
// services
import LocaleService from 'modules/Localization';
// store
import { useStore } from 'modules/Stores';
// utils
import { dividePercentage } from '../../utils';
// assets
import { ProgressIcon } from '../ProgressIcon';
import * as css from '../../styles';

const ChartSyncProgress = () => {
  const { chartLayoutResults, studyTemplateResults } = useStore(
    'ChartSyncStore',
  );

  const totalChartsAndTemplates =
    chartLayoutResults.total + studyTemplateResults.total;

  const uploadedChartsAndTemplates =
    chartLayoutResults.errorCount +
    chartLayoutResults.successCount +
    studyTemplateResults.successCount +
    studyTemplateResults.errorCount;

  const filledCount = dividePercentage(
    (uploadedChartsAndTemplates / totalChartsAndTemplates) * 100,
  );

  return (
    <React.Fragment>
      <View justifyContent="center">
        <ProgressIcon filledCount={filledCount} />
      </View>
      <View
        padding={['large', 'xxxlarge']}
        flexDirection="column"
        gap="small"
        alignItems="center"
      >
        <Text css={css.heading}>
          {LocaleService.translate('UPLOADING_TO_CLOUD')}
        </Text>
        <Text css={css.description}>
          {LocaleService.translate('UPLOADING_TO_CLOUD_IN_PROGRESS')}
        </Text>
      </View>
    </React.Fragment>
  );
};

export default observer(ChartSyncProgress);
